import { uploadCroppedImage } from "../common/file_upload";

$(function() {
  "use strict";

  const IS_WORKPLACE_HEAD_OFFICE_OTHER = '2';
  const ISSUE_TYPE_OTHER = '99';
  const ROUTE_TYPE_OTHER = '99';
  const USING_SERVICE_OTHER = '99';

  // 画像ロゴの同意にチェックON
  $('#is_agree').on('change', function() {
    $('#company_logo_image_form').prop('disabled', !$('#is_agree').prop('checked'));
    $('#company_banner_image_form').prop('disabled', !$('#is_agree').prop('checked'));
  });

  // 勤務先でその他を選択時
  $('input[name=is_workplace_head_office]:radio').change(function() {
    $('#workplace').prop('disabled', $('input[name=is_workplace_head_office]:checked').val() !== IS_WORKPLACE_HEAD_OFFICE_OTHER);
  }).trigger('change');

  // 解決したいと考えている課題でその他を選択時
  $('input[name="issue_type[]"]').change(function() {
    let disabledFlg = true;
    $('input[name="issue_type[]"]:checked').each(function () {
      if ($(this).val() === ISSUE_TYPE_OTHER) {
        disabledFlg = false;
      }
    });
    $('#issue_other').prop('disabled', disabledFlg);
  }).trigger('change');

  // IeReを知ったきっかけでその他を選択時
  $('input[name="company_questionnaire[route_type]"]:radio').change(function() {
    $('#route_other').prop('disabled', $('input[name="company_questionnaire[route_type]"]:checked').val() !== ROUTE_TYPE_OTHER);
  }).trigger('change');

  // 現在利用しているサービスでその他を選択時
  $('input[name="company_questionnaire[using_service][]"]').change(function() {
    let disabledFlg = true;
    $('input[name="company_questionnaire[using_service][]"]:checked').each(function () {
      if ($(this).val() === USING_SERVICE_OTHER) {
        disabledFlg = false;
      }
    });
    $('#using_service_other').prop('disabled', disabledFlg);
  }).trigger('change');

  // 3桁ごとにスペースを挿入
  $('#capital_amount_input').on('input', function() {
    let input = $(this).val().replace(/\D/g, '');
    let formattedInput = input.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    $(this).val(formattedInput);
  }).trigger('input');

  // ロゴ画像アップロード
  $('#company_logo_image_form').on('change', function () {
    uploadCroppedImage($(this), '/company/user/upload-image', 'company_logo_image', 1 / 1);
  });

  // バナー画像アップロード
  $('#company_banner_image_form').on('change', function () {
    uploadCroppedImage($(this), '/company/user/upload-image', 'company_banner_image', 16 / 9);
  });
});
